import React from 'react';
import { personalInfo, bio } from '../mock';
import { MapPin, Shield, Terminal } from 'lucide-react';

const About = () => {
  return (
    <section id="about" style={{
      minHeight: '100vh',
      padding: '160px 7.6923% 100px',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Section header */}
        <div style={{ marginBottom: '80px', textAlign: 'center' }}>
          <div style={{
            fontFamily: 'monospace',
            fontSize: '14px',
            color: '#00FFD1',
            marginBottom: '16px',
            letterSpacing: '2px'
          }}>
            {'>> CLASSIFIED DOSSIER'}
          </div>
          <h2 style={{
            fontSize: '48px',
            fontWeight: 600,
            lineHeight: 1.1,
            color: '#FFFFFF',
            marginBottom: '24px'
          }}>
            Identity Profile
          </h2>
        </div>

        {/* Two column layout */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: '60px',
          alignItems: 'start'
        }}>
          {/* Left - Dossier card */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(0, 255, 209, 0.3)',
            padding: '48px',
            position: 'relative',
            transition: 'all 0.4s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.border = '1px solid rgba(0, 255, 209, 0.6)';
            e.currentTarget.style.boxShadow = '0 0 30px rgba(0, 255, 209, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.border = '1px solid rgba(0, 255, 209, 0.3)';
            e.currentTarget.style.boxShadow = 'none';
          }}
          >
            {/* Scanline effect */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '2px',
              background: '#00FFD1',
              boxShadow: '0 0 10px rgba(0, 255, 209, 0.8)',
              animation: 'scan 3s linear infinite'
            }} />

            <div style={{
              fontFamily: 'monospace',
              color: '#FFFFFF'
            }}>
              <div style={{ marginBottom: '32px' }}>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#4D4D4D', 
                  marginBottom: '8px',
                  letterSpacing: '1px'
                }}>
                  IDENTITY:
                </div>
                <div style={{ fontSize: '28px', fontWeight: 600, color: '#00FFD1' }}>
                  {personalInfo.alias}
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#4D4D4D', 
                  marginBottom: '8px',
                  letterSpacing: '1px'
                }}>
                  REAL NAME:
                </div>
                <div style={{ fontSize: '20px', fontWeight: 500 }}>
                  {personalInfo.name}
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#4D4D4D', 
                  marginBottom: '8px',
                  letterSpacing: '1px'
                }}>
                  SPECIALIZATION:
                </div>
                <div style={{ fontSize: '16px', lineHeight: 1.6 }}>
                  DevOps | Cloud | Cybersecurity | AI Automation
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#4D4D4D', 
                  marginBottom: '8px',
                  letterSpacing: '1px'
                }}>
                  ROLE:
                </div>
                <div style={{ fontSize: '16px', lineHeight: 1.6 }}>
                  Commander of ShadowMind Systems
                </div>
              </div>

              <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MapPin size={16} style={{ color: '#00FFD1' }} />
                <div style={{ fontSize: '16px' }}>
                  {personalInfo.location}
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Shield size={16} style={{ color: '#00FFD1' }} />
                <div style={{ fontSize: '16px', color: '#00FFD1' }}>
                  CLEARANCE: {personalInfo.clearance}
                </div>
              </div>
            </div>
          </div>

          {/* Right - Bio */}
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '32px'
            }}>
              <Terminal size={24} style={{ color: '#00FFD1' }} />
              <div style={{
                fontSize: '24px',
                fontWeight: 600,
                color: '#FFFFFF'
              }}>
                Mission Overview
              </div>
            </div>

            <div style={{
              fontSize: '18px',
              lineHeight: 1.8,
              color: 'rgba(255, 255, 255, 0.85)',
              fontFamily: 'monospace'
            }}>
              {bio.map((item, index) => (
                <div key={index} style={{
                  marginBottom: '24px',
                  paddingLeft: '24px',
                  borderLeft: '2px solid rgba(0, 255, 209, 0.3)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderLeft = '2px solid #00FFD1';
                  e.currentTarget.style.paddingLeft = '32px';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderLeft = '2px solid rgba(0, 255, 209, 0.3)';
                  e.currentTarget.style.paddingLeft = '24px';
                }}
                >
                  <span style={{ color: '#00FFD1', marginRight: '12px' }}>{'>'}</span>
                  {item}
                </div>
              ))}
            </div>

            {/* Stats */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '24px',
              marginTop: '60px'
            }}>
              {[
                { label: 'Cloud Migrations', value: '5+' },
                { label: 'AI Frameworks', value: '3' },
                { label: 'Years Experience', value: '4+' }
              ].map((stat, index) => (
                <div key={index} style={{
                  textAlign: 'center',
                  padding: '24px',
                  background: 'rgba(0, 255, 209, 0.05)',
                  border: '1px solid rgba(0, 255, 209, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(0, 255, 209, 0.1)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(0, 255, 209, 0.05)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                >
                  <div style={{
                    fontSize: '32px',
                    fontWeight: 600,
                    color: '#00FFD1',
                    marginBottom: '8px',
                    fontFamily: 'monospace'
                  }}>
                    {stat.value}
                  </div>
                  <div style={{
                    fontSize: '14px',
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontFamily: 'monospace'
                  }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scan {
          0% {
            top: 0;
          }
          100% {
            top: 100%;
          }
        }

        @media (max-width: 768px) {
          #about > div > div:last-child {
            grid-template-columns: 1fr !important;
          }
          #about > div > div:last-child > div:last-child > div:last-child {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default About;